module.exports = __webpack_public_path__ + "img/stop-program.dcc13951.svg";